<div class="side-sheet" [ngClass]="{'active': open}">
  <div class="d-flex h-100">

    <div class="overlay" (click)="close.emit()"></div>

    <div class="sheet-container">

      <ng-content *ngIf="open"></ng-content>

    </div>

  </div>
</div>
